// extracted by mini-css-extract-plugin
module.exports = {"reset_password_form":"ResetPasswordForm_reset_password_form__2Xtc_","warn_text":"ResetPasswordForm_warn_text__1I691"};